function setupNumSelectors() {
    $('.num-selector__minus:not(.readonly)').click(function() {
        $input = $(this).parent().find('input[type=number]');
        $input.val(parseInt($input.val()) - 1);
        $input.change();
    });
    $('.num-selector__plus:not(.readonly)').click(function() {
        $input = $(this).parent().find('input[type=number]');
        $input.val(parseInt($input.val()) + 1);
        $input.change();
    });
}
$(document).ready(setupNumSelectors);
